import {
  BackendSmartAccount,
  BackendTransaction,
  SmartAccountRole,
} from '~/types'

export function getSmartAccountRole(
  smartAccount: BackendSmartAccount | undefined,
  transaction: BackendTransaction,
): SmartAccountRole | undefined {
  return (
    (smartAccount && !smartAccount.isPublicSmartAccount
      ? smartAccount.role
      : undefined) ??
    ('smartAccountRole' in transaction
      ? transaction.smartAccountRole
      : undefined)
  )
}
